import { Flex } from 'pcln-design-system'
import React, { useContext } from 'react'
import { BootstrapDataContext } from '../../../contexts'
import IncredibleTileExperiment from '../../../experiments/IncredibleTileExperiment'
import PricebreakersPromo from '../../promos/pricebreakers-promo'
import VIPPromo from '../../promos/express-promo/VIPPromo'
import CrossSellPromo from '../cross-sell'
import { complement, either, isEmpty, isNil } from 'ramda'
import CrossSellInventory from '../cross-sell/CrossSellInventory'
import { useSeti } from '../../hooks'

const isTruthy = complement(either(isNil, isEmpty))

/**
 *
 * @param {string} firstName - customer first name, if it exists
 * @param {boolean} shouldShowInventory - whether or not to show the component w/ inventory
 * @param {Object} mostRecentBooking - a customer's most recent booking if it exists
 */
// eslint-disable-next-line react/prop-types
function renderCrossSell ({ firstName = '', shouldShowInventory, mostRecentBooking }) {
  if (shouldShowInventory) {
    return <CrossSellInventory firstName={firstName} booking={mostRecentBooking} />
  }

  return <CrossSellPromo firstName={firstName} booking={mostRecentBooking} />
}

const SignedOutExperience = () => <PricebreakersPromo />

export default function PromotionBanner () {
  const {
    signInStatus = { signedIn: false, passiveSignIn: false },
    pclnData: {
      firstName = ''
    },
    mostRecentBooking = null
  } = useContext(BootstrapDataContext)

  const isSignedIn = signInStatus.signedIn || signInStatus.passiveSignIn
  const whenBookingExists = isTruthy(mostRecentBooking)
  const shouldShowInventory = useSeti('HP_XSELL_INVENTORY_COVID_STRATEGIC', false) === 'XSELL_INVENTORY' && isSignedIn && whenBookingExists
  const signedInExperience = whenBookingExists ? renderCrossSell({ firstName, shouldShowInventory, mostRecentBooking }) : <VIPPromo />

  return (
    <Flex my={3} mx='auto' justifyContent='center'>
      <Flex style={{ maxWidth: '1280px', flex: '1 1 100%' }} px='20px'>
        {
          isSignedIn
            ? signedInExperience
            : <SignedOutExperience />
        }
        {/* inventory component leaves no room for this tile experiment */}
        {!shouldShowInventory && <IncredibleTileExperiment />}
      </Flex>
    </Flex>
  )
}
